/* eslint-disable react/prefer-es6-class, react/sort-comp, react/jsx-indent */
import classnames from 'classnames';
import React from 'react';
import { ItemsRequiredForStudy } from 'es6/models/goal';
import { formatNumber } from 'es6/helpers/numbers';
import { t } from 'es6/services/localization';
import * as Paths from 'es6/core/paths';
import { RadialProgress, RadialProgressSentenceTrainer } from 'es6/components/common/radial-progress';
import { TranscodedImageSizes, TranscodedImage } from 'es6/components/common/transcoded-image';

export default React.createClass({
  displayName: 'CourseSummary',

  propTypes: {
    aggregateMemory: React.PropTypes.object,
    goal: React.PropTypes.object.isRequired,
    enableCourseActions: React.PropTypes.bool,
    enableCourseLauncher: React.PropTypes.bool,
    enableCourseProgress: React.PropTypes.bool,
    isLoading: React.PropTypes.bool,
    onEnroll: React.PropTypes.func.isRequired,
    onFocus: React.PropTypes.func.isRequired,
    onUnenroll: React.PropTypes.func.isRequired,
    onUnfocus: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      aggregateMemory: null,
      enableCourseActions: true,
      enableCourseLauncher: true,
      enableCourseProgress: true,
      isLoading: false,
    };
  },

  render() {
    const goal = this.props.goal;
    const className = classnames('course', {
      'course-actions-enabled': this.props.enableCourseActions,
      'course-launcher-enabled': this.props.enableCourseLauncher,
      'course-progress-enabled': this.props.enableCourseProgress,
      waiting: this.props.isLoading,
    });

    return (
      <div className={className}>
        <header className="content-details">
          <div className="details-primary course-title ellipsis" title={goal.title}>{goal.title}</div>
          <div className="details-secondary">
            {this._renderActions()}
          </div>
        </header>

        <div className="content-primary content-columns">
            <div className="content-column course-picture">
              <TranscodedImage size={TranscodedImageSizes.LARGE} src={goal.icon} />
            </div>

            <div className="content-column course-data">
              {this._renderSeries()}

              <div className="content-columns stats">
                <div className="content-column stat level">
                  <span className="secondary">{t('level-label')} </span>
                  <span className="primary">{goal.getDifficultyLevel()}</span>
                </div>
              </div>

              <div className="content-columns stats">
                <div className="content-column stat items">
                  <span className="secondary">{t('items-label')} </span>
                  <span className="primary">{goal.itemsCount}</span>
                </div>

                <div className="content-column stat sentences">
                  <span className="secondary">{t('sentences-label')} </span>
                  <span className="primary">{goal.sentencesCount}</span>
                </div>

                <div className="content-column stat enrolled">
                  <span className="secondary">{t('users-label')} </span>
                  <span className="primary">{formatNumber(goal.usersCount)}</span>
                </div>
              </div>

              <div className="description">
                <p>{goal.description}</p>
              </div>

              {this._renderCourseLauncher()}
            </div>

            {this._renderCourseProgress()}
          </div>
      </div>
    );
  },

  /**
   * Helper method for rendering an action link.
   *
   * @param {String} label
   * @param {Function} callback
   * @returns {ReactElement}
   */
  _renderActionLink(label, callback) {
    const onClick = callback.bind(null, this.props.goal.id);

    return (
      <span key={label} className="action-link course-action" onClick={onClick}>{label}</span>
    );
  },

  /**
   * Render the action links for the course summary. Don't show
   * anything if the course summary has an isLoading or if the
   * user is unauthenticated.
   *
   * @returns {ReactElement}
   */
  _renderActions() {
    const aggregateMemory = this.props.aggregateMemory;
    const goal = this.props.goal;

    // A course that isn't studiable can't have actions performed on it.
    if (!this.props.isLoading && this.props.enableCourseActions && goal.isStudiable()) {
      if (!aggregateMemory.enrolled) {
        return [
          this._renderActionLink(t('add to focus'), this.props.onFocus),
          this._renderActionLink(t('save-for-later'), this.props.onEnroll),
        ];
      } else if (aggregateMemory.focused) {
        return [
          this._renderActionLink(t('save-for-later'), this.props.onUnfocus),
          this._renderActionLink(t('remove-from-studying'), this.props.onUnenroll),
        ];
      } else if (aggregateMemory.enrolled) {
        return [
          this._renderActionLink(t('add to focus'), this.props.onFocus),
          this._renderActionLink(t('remove-from-saved'), this.props.onUnenroll),
        ];
      }
    }

    // Fall back by returning nothing.
    return null;
  },

  /**
   * Renders the course launcher if it is enabled and course is studiable.
   *
   * @returns {ReactElement}
   */
  _renderCourseLauncher() {
    if (!this.props.enableCourseLauncher || !this.props.goal.isStudiable()) {
      return null;
    }

    return (
      <div className="course-launcher">
        <a href={Paths.studyGoal(this.props.goal.id)} className="btn btn-bar btn-primary" rel="app">{t('start')}</a>
      </div>
    );
  },

  /**
   * Does not render course progress if it is enabled.
   *
   * @returns {ReactElement}
   */
  _renderCourseProgress() {
    const aggregateMemory = this.props.aggregateMemory;

    if (!this.props.enableCourseProgress) {
      return null;
    }

    // If the goal is not studiable, put up a message indicating that.
    if (!this.props.goal.isStudiable()) {
      return (
        <div className="content-column course-progress">
          <p className="warning-message">{t('add at least {count} items needed to study & publish', { count: ItemsRequiredForStudy })}</p>
        </div>
      );
    }

    return (
      <div className="content-column course-progress">
        <header className="course-progress-header">{t('study-progress.label')}</header>

        <div className="radial-progress-container">
          <RadialProgress progress={aggregateMemory.items.progress} />
          <span className="progress-domain">{t('iknow.label')}</span>
        </div>

        <div className="radial-progress-container">
          <RadialProgressSentenceTrainer level={aggregateMemory.sentences.level} progress={aggregateMemory.sentences.progress} />
          <span className="progress-domain">{t('app-branding.sentence-trainer')}</span>
        </div>
      </div>
    );
  },

  /**
   * Renders series details if they are available.
   *
   * @returns {ReactElement}
   */
  _renderSeries() {
    const series = this.props.goal.series;

    if (!series) {
      return null;
    }

    return (
      <div className="content-columns stats">
        <div className="content-column stat series">
          <span className="secondary">{t('series-label')} </span>
          <span className="primary">
            <a href={Paths.series(series.id)}>{series.name}</a>
          </span>
        </div>
      </div>
    );
  },
});
